import React, { createContext, useContext } from 'react';

// Shape carried by ProfileContext. Identical to the props App.js was
// threading through every page (profile, user, score, trial, isLinked)
// plus the fetcher pages use to refresh after a settings change. By
// hoisting this into a context, downstream consumers (pages, cards)
// stop accepting these as props and the App.js route tree simplifies.
const ProfileContext = createContext({
  profile: null,
  user: null,
  score: 0,
  trial: null,
  isLinked: false,
  fetchProfile: async () => {},
  setProfile: () => {},
});

export function ProfileProvider({ value, children }) {
  return (
    <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>
  );
}

export function useProfile() {
  return useContext(ProfileContext);
}
